import { Injectable } from '@angular/core';

export interface ApplicationType {
  IsVisol: boolean;
}

export const REPORT_TEMPLATE___APPLICATION_TYPE = 'report_template___application_type';

@Injectable()
export class StorageService {

  constructor() { }

  fetchApplicationType(key: string): ApplicationType {
    const json = sessionStorage.getItem(key);
    if (!json) { return null; }
    return JSON.parse(json);
  }

  pushApplicationType(key: string, applicationType: ApplicationType): void {
    sessionStorage.setItem(key, JSON.stringify(applicationType));
  }
}
